import React, { useEffect, useState } from 'react';
import Card from '../Card/Card';
import Cart from '../Cart/Cart';
import './Body.css';

const Body = () => {
    const [ cakes, setCakes ] = useState([]);
    useEffect(()=>{

        fetch('data.json')
        .then(res => res.json())
        .then(data => setCakes(data))
    },[])

    const [ cart, setCart ] = useState([]);

    const addToCart = (cake) => {
        const exist = cart.find(item => item.name === cake.name);
        if(cart.length <= 3 && !exist) {
                setCart([...cart,cake])
        } else {
            alert('cant add more')
        }
    }

    const removeCart = () => {
        if(cart.length > 0) {
            cart.length = 0;
        setCart([...cart]);
        }
    }

    return (
        <div className='body'>
            <div className='card-container'>
            {
                cakes.map(cake => <Card 
                    cake={cake}
                    addToCart={addToCart}
                    key={cake.id}></Card>)
            }
        </div>
        <div>
            <Cart 
            cart={cart}
            removeCart={removeCart}
             ></Cart>
        </div>

        </div>
    );
};

export default Body;